<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container2">
          <!--
            Loader old
           <div class="swapping-squares-spinner">
            <div class="square"></div>
            <div class="square"></div>
            <div class="square"></div>
            <div class="square"></div>
          </div>-->

          <div class="loadingio-spinner-dual-ring-qavmqln88ue">
            <div class="ldio-3bu2kssjmmy">
              <div></div>
              <div>
                <div></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
};
</script>

<style lang="scss">
.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>


<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  /* background-color: rgba(83, 82, 85, 0.80); */
  background-color: #eeeeee;
  display: table;
  -webkit-transition: opacity 0.15s ease;
  transition: opacity 0.1s ease-out;
}

.modal-container2 {
  max-width: 65px;
  margin: 0px auto;
  position: relative;
  background-color: #fff0;
  /* -webkit-transition: all .3s ease; */
  /* transition: all .3s ease; */
  -webkit-box-shadow: 0;
  box-shadow: 0;
  border-radius: 6px;
  border: none;
}

.swapping-squares-spinner,
.swapping-squares-spinner * {
  box-sizing: border-box;
}

.swapping-squares-spinner {
  height: 65px;
  width: 65px;
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.swapping-squares-spinner .square {
  height: calc(65px * 0.25 / 1.3);
  width: calc(65px * 0.25 / 1.3);
  animation-duration: 1000ms;
  border: calc(65px * 0.04 / 1.3) solid #ff1d5e;
  margin-right: auto;
  margin-left: auto;
  position: absolute;
  animation-iteration-count: infinite;
}

.swapping-squares-spinner .square:nth-child(1) {
  animation-name: swapping-squares-animation-child-1;
  animation-delay: 500ms;
}

.swapping-squares-spinner .square:nth-child(2) {
  animation-name: swapping-squares-animation-child-2;
  animation-delay: 0ms;
}

.swapping-squares-spinner .square:nth-child(3) {
  animation-name: swapping-squares-animation-child-3;
  animation-delay: 500ms;
}

.swapping-squares-spinner .square:nth-child(4) {
  animation-name: swapping-squares-animation-child-4;
  animation-delay: 0ms;
}

@keyframes swapping-squares-animation-child-1 {
  50% {
    transform: translate(150%, 150%) scale(2, 2);
  }
}

@keyframes swapping-squares-animation-child-2 {
  50% {
    transform: translate(-150%, 150%) scale(2, 2);
  }
}

@keyframes swapping-squares-animation-child-3 {
  50% {
    transform: translate(-150%, -150%) scale(2, 2);
  }
}

@keyframes swapping-squares-animation-child-4 {
  50% {
    transform: translate(150%, -150%) scale(2, 2);
  }
}
</style>




<style type="text/css">
@keyframes ldio-3bu2kssjmmy {
  0% {
    transform: rotate(0);
  }
  100% {
    transform: rotate(360deg);
  }
}
.ldio-3bu2kssjmmy div {
  box-sizing: border-box !important;
}
.ldio-3bu2kssjmmy > div {
  position: absolute;
  width: 72px;
  height: 72px;
  top: 14px;
  left: 14px;
  border-radius: 50%;
  border: 8px solid #000;
  border-color: #4caf50 transparent #4caf50 transparent;
  animation: ldio-3bu2kssjmmy 1s linear infinite;
}
.ldio-3bu2kssjmmy > div:nth-child(2) {
  border-color: transparent;
}
.ldio-3bu2kssjmmy > div:nth-child(2) div {
  position: absolute;
  width: 100%;
  height: 100%;
  transform: rotate(45deg);
}
.ldio-3bu2kssjmmy > div:nth-child(2) div:before,
.ldio-3bu2kssjmmy > div:nth-child(2) div:after {
  content: "";
  display: block;
  position: absolute;
  width: 8px;
  height: 8px;
  top: -8px;
  left: 24px;
  background: #4caf50;
  border-radius: 50%;
  box-shadow: 0 64px 0 0 #4caf50;
}
.ldio-3bu2kssjmmy > div:nth-child(2) div:after {
  left: -8px;
  top: 24px;
  box-shadow: 64px 0 0 0 #4caf50;
}
.loadingio-spinner-dual-ring-qavmqln88ue {
  width: 100px;
  height: 100px;
  display: inline-block;
  overflow: hidden;
  background: none;
}
.ldio-3bu2kssjmmy {
  width: 100%;
  height: 100%;
  position: relative;
  transform: translateZ(0) scale(1);
  backface-visibility: hidden;
  transform-origin: 0 0; /* see note above */
}
.ldio-3bu2kssjmmy div {
  box-sizing: content-box;
}
/* generated by https://loading.io/ */
</style>